import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import Dropzone from 'react-dropzone';
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Row,
  Col
} from 'react-bootstrap';
import { MapPanel } from 'components';

class MapsList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ul className='list-group map-list-group mt-lg'>
        {this.props.mapCreator.maps_list.map(map => <MapPanel key={map._id} map={map} />)}
      </ul>
    );
  }
}

export default mapCreatorConnect(MapsList);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/maps-list.js